import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom';

import AuthenticatedRoute from '../../../middlewares/AuthenticatedRoute'
import Bookings from './bookings/Bookings'

const BookingsTracker = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <AuthenticatedRoute exact path={path}>
                <Bookings title={'Booking Tracker'} />
            </AuthenticatedRoute>
        </Switch>
    )
}

export default BookingsTracker;
